/* MATCHING RULR */

export const RESET_MATCHING_RULES = "RESET_MatCHING_RULES"
export const GET_MESSAGETYPE = "GET_MESSAGETYPE"
export const GET_FIELDS = "GET_FIELDS"
export const SET_PROCESSING_MATCHING_RULE = "SET_PROCESSING_MATCHING_RULE"
export const STOP_PROCESSING_MATCHING_RULE = "STOP_PROCESSING_MATCHING_RULE"




/*  MATCHING DAY */
export const SEARCH_MATCHING_DAY = "SEARCH_MATCHING_DAY";
export const RESET_MATCHING_DAY = "RESET_MATCHING_DAY";
export const SET_PROCESSING_MATCHING_DAY = "SET_PROCESSING_MATCHING_DAY";
export const STOP_PROCESSING_MATCHING_DAY = "STOP_PROCESSING_MATCHING_DAY";
export const GET_ELEMENTS = "GET_ELEMENTS";
export const GET_RULES = "GET_RULES"